module.exports = __webpack_public_path__ + "media/fuzion-1.84f4b8d3.mp4";